import { render } from "./BaseInputText.vue?vue&type=template&id=ff518b28&scoped=true"
import script from "./BaseInputText.vue?vue&type=script&lang=ts"
export * from "./BaseInputText.vue?vue&type=script&lang=ts"

import "./BaseInputText.vue?vue&type=style&index=0&id=ff518b28&lang=css"
import "./BaseInputText.vue?vue&type=style&index=1&id=ff518b28&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-ff518b28"

export default script